export class BaseDTO{
    Id: number;
    Enabled: boolean;
    IsSelected: boolean;
}


